module.exports = __webpack_public_path__ + "media/KikiK2.c666ccc4.mp3";